import { render, staticRenderFns } from "./CommentsTableRowBody.vue?vue&type=template&id=067c2534&"
import script from "./CommentsTableRowBody.vue?vue&type=script&lang=ts&"
export * from "./CommentsTableRowBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports